import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex h-full w-full flex-col gap-10 max-md:block',
    filterButton: 'flex-center h-8 px-0',
    filterButtonChildren: 'flex-center gap-[6px] max-md:normal-case md:gap-2',
    filterIcon: 'h-6 w-6 md:h-8 md:w-8',
    drawer: 'py-[20px] pb-0 sm:py-12 sm:pb-0',
    resetButton:
      'text-secondary-hover h-fit self-end p-0 text-sm font-semibold',
    titleWrapper: 'flex items-center gap-2 max-md:pb-10 md:justify-between',
    title: 'text-xl font-semibold md:text-3xl',
    filters: '-mr-3 flex flex-col overflow-y-auto pr-3',
    filter: 'mb-8 flex flex-col gap-x-4 gap-y-2 last:mb-8',
    filterTitle: 'text-s leading-normal font-semibold',
    footer: 'sticky bottom-0 mt-auto flex bg-white pb-[10px] max-md:pt-10',
    showProductsButton:
      'bg-primary hover:bg-blue bg-blue-dark w-full rounded py-3 font-medium text-white disabled:cursor-not-allowed disabled:bg-gray-300'
  },
  variants: {
    hide: {
      true: {
        filterTitle: 'hidden'
      }
    },
    isNextCheckbox: {
      true: {
        filter: 'mb-1'
      }
    }
  },
  defaultVariants: {}
});
